<template>
    <div>
      <div class="snippet event-domain-snippet">
        
         <div class="form-group row">
          <div class="col-lg-8 mt-3">
            <label>Footer Text</label>
            <textarea
              class="form-control"
              :value="item.footer_text"
              @input="updateFooterText"
              placeholder="Enter Footer Text"
              rows="3"
            ></textarea>
          </div>
        </div>

        <div class="form-group row">
          <div class="col-lg-8 mt-3">
            <label>Registration Text</label>
            <textarea
              class="form-control"
              :value="item.registeration_text"
              @input="updateRegistrationText"
              placeholder="Enter Registration Text"
              rows="3"
            ></textarea>
          </div>
        </div>
  
        <div class="form-group row">
          <div class="col-lg-8 mt-3">
            <label>Conference/Schedule Text</label>
            <textarea
              class="form-control"
              :value="item.conference_text"
              @input="updateConferenceText"
              placeholder="Enter Conference / Schedule Text"
              rows="3"
            ></textarea>
          </div>
        </div>
  
        <div class="form-group row">
          <div class="col-lg-8 mt-3">
            <label>Keynote Speaker Text</label>
            <textarea
              class="form-control"
              :value="item.keynote_speaker_text"
              @input="updateKeynoteSpeakerText"
              placeholder="Enter Keynote Speaker Text"
              rows="3"
            ></textarea>
          </div>
        </div>
  
        <div class="form-group row">
          <div class="col-lg-8 mt-3">
            <label>Event Gallery Text</label>
            <textarea
              class="form-control"
              :value="item.event_galary_text"
              @input="updateEventGalleryText"
              placeholder="Enter Gallery Text"
              rows="3"
            ></textarea>
          </div>
        </div>
  
        <div class="form-group row">
          <div class="col-lg-8 mt-3">
            <label>Event Sponsor Text</label>
            <textarea
              class="form-control"
              :value="item.sponsor_text"
              @input="updateSponsorText"
              placeholder="Enter Sponsor Text"
              rows="3"
            ></textarea>
          </div>
        </div>
  
        <div class="form-group row">
          <div class="col-lg-8 mt-3">
            <label>Event Exhibitor Text</label>
            <textarea
              class="form-control"
              :value="item.event_exhibitors_text"
              @input="updateExhibitorText"
              placeholder="Enter Exhibitor Text"
              rows="3"
            ></textarea>
          </div>
        </div>
  
        <div class="form-group row">
          <div class="col-lg-8 mt-3">
            <label>Event Agenda Text</label>
            <textarea
              class="form-control"
              :value="item.on_demand_text"
              @input="updateOnDemandText"
              placeholder="Enter On Demand Text"
              rows="3"
            ></textarea>
          </div>
        </div>
  
      </div>
    </div>
  </template>
  

<script>
import {mapActions, mapGetters} from "vuex";
import _ from 'lodash';
import InputSwitch from "@/components/Commons/InputSwitch";

export default {
    name: "ThemeContentsTab",
    components: {
     
  },
    data() {
        return {
            event_theme: null,
        };
    },
    computed: {
        ...mapGetters("LandingPageSettingsSingle", [
            "item",
            "event_type",
            "skyboxes",
            "environments"
        ])
    },
    watch: {
        
    },
    methods: {
        ...mapActions("LandingPageSettingsSingle", [
            "setEvent",
            "setRegistrationText",
            "setConferenceText",
            "setEventGalleryText",
            "setSponsorText",
            "setKeynoteSpeakerText",
            "setExhibitorText",
            "setOnDemandText",
            "setFooterText"

        ]),

        validate_file(fileInfo) {
            if (_.has(fileInfo, 'key'))
                return fileInfo;
        return null;
        },
        updateRegistrationText(e){
            this.setRegistrationText(e.target.value);
        },
        updateConferenceText(e){
            this.setConferenceText(e.target.value);
        },
        updateKeynoteSpeakerText(e){
            this.setKeynoteSpeakerText(e.target.value);
        },
        updateEventGalleryText(e){
            this.setEventGalleryText(e.target.value);
        },
        updateSponsorText(e){
            this.setSponsorText(e.target.value);
        },
        updateExhibitorText(e){
            this.setExhibitorText(e.target.value);
        },
        updateOnDemandText(e){
            this.setOnDemandText(e.target.value);
        },
        updateFooterText(e){
          this.setFooterText(e.target.value);    
        }
        
        
        
      
    }
}
</script>

<style scoped>

</style>